import React from "react";
import { GraphicChart } from "../../../PricesChart";
import { RiBarChartGroupedFill } from "react-icons/ri";
import { isMobile } from "react-device-detect";
import { IoIosPhoneLandscape } from "react-icons/io";
import Skeleton from "react-loading-skeleton";

/**
 * Card with technical chart (price change).
 */
export function TechnicalGraphicChartCard({ analysisData }) {
  if (!analysisData) {
    return loadingSkeleton();
  }

  const chartDataStatus = analysisData.requestsResults.Chart;
  if (chartDataStatus === 7) {
    const chartData = analysisData.analysisResults.Chart;
    return (
      <div className="media-body ht-100p animated fadeInDown" id={!isMobile ? "analysis-step-5" : ''}>
        <div
          className="card card-minimal-three chart"
          style={{
            borderRadius: 10,
            boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
            borderColor: "var(--border-4)",
          }}
        >
          <div className="card-header">
            <h4>Gráfico Diário</h4>
            <p>
              <span>
                Com ele você pode acompanhar movimentos de preços do ativo.{" "}
                <br />
              </span>
              {isMobile && (
                <span>
                  Para uma <b>melhor visualização</b>, recomendados que{" "}
                  <b>gire seu celular.</b> <IoIosPhoneLandscape size={20} />
                </span>
              )}
            </p>
          </div>
          <div className="card-body ht-100p">
            <div id={isMobile ? "analysis-step-5" : ''}>{GraphicChart(chartData)}</div>
          </div>
        </div>
      </div>
    );
  } else {
    return errorMessage();
  }
}

export const TechnicalGraphicChartCardMemo = React.memo(
  TechnicalGraphicChartCard
);

const errorMessage = () => {
  return (
    <div className="animated fadeInDown">
      <div className="media-body">
        <div
          className="card card-minimal-three"
          style={{
            borderRadius: 10,
            width: "100%",
            boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
            borderColor: "var(--border-4)",
          }}
        >
          <div className="card-body">
            <div className="pd-50" style={{ justifyContent: "center" }}>
              <div style={{ justifyContent: "center", display: "flex" }}>
                <i>
                  <RiBarChartGroupedFill size={32} />
                </i>
              </div>
              <div style={{ justifyContent: "center", display: "flex" }}>
                <h3>Gráfico indisponível</h3>
              </div>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  fontSize: 15,
                  textAlign: "center",
                }}
              >
                Infelizmente, os gráficos de movimento de preço não estão
                disponíveis no momento.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const loadingSkeleton = () => {
  return (
    <div className="animated fadeInDown">
      <div className="media-body">
        <div
          className="card card-minimal-three"
          style={{
            borderRadius: 10,
            boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
            borderColor: "var(--border-4)",
          }}
        >
          <div className="card-header">
            <h4>Gráfico Diário</h4>
            <p>
              <span>
                Com ele você pode acompanhar movimentos de preços do ativo.{" "}
                <br />
              </span>
            </p>
          </div>
          <div className="card-body">
            <div className="pd-50">
              <div style={{ justifyContent: "center" }}></div>
              <p>
                <span>
                  <Skeleton height={16} count={7} style={{ marginTop: 10 }} />
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
